import { withErrorBoundary } from 'config/sentry';

import ErrorMessage from '../components/ErrorMessage';

export default Component =>
    withErrorBoundary(Component, {
        fallback: <ErrorMessage />,
    });
